import axios from "axios";

export async function uploadMediaFile(file: File, url: string): Promise<void> {
  const encodedFileName = encodeURIComponent(file.name);

  try {
    await axios.create().put(url, file, {
      timeout: 60 * 60 * 1000,
      headers: {
        "Content-Type": "multipart/form-data",
        "x-ms-blob-type": "BlockBlob",
        "x-ms-meta-fileName": encodedFileName,
        "x-ms-blob-content-disposition": `attachment; filename="${encodedFileName}"`,
      },
    });
  } catch (e: unknown) {
    console.log(e);
  }
}
